import Link from 'next/link';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

//hooks
import useMarketingUrl from '@/utils/urls/useMarketingUrl';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

//libs
import {
    displayedData,
    textStyle,
    getDataRetention
} from '@/lib/settings/subscriptionInvoices/currentPlan';
import { trialPlanOptions } from '@/lib/PricingCards/trialPlanOptions';

//components
import H3 from '@/components/base/Headings/H3';
import { UserPlanCard } from '@/components/composite/PricingCards/UserPlanCard';

function DataWrapper({ title, description }) {
    return (
        <div className="flex flex-col space-y-1.5 rounded-md bg-icoGray-100 px-10 py-5 dark:bg-icoDarkMode-deepBlack">
            <H3>{title}</H3>
            <span className="font-GMedium text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                {description}
            </span>
        </div>
    );
}

export function CurrentPlan() {
    const { subscription } = useSubscription();
    const { t } = useTranslation();
    const { marketingUrl } = useMarketingUrl();

    const subscriptionPlan = subscription?.product_key;
    const variant = subscriptionPlan === 'trial' ? 'teams' : subscriptionPlan;
    const userCount =
        subscriptionPlan === 'trial'
            ? trialPlanOptions.nb_users
            : subscription?.options.users.count_total;
    const SocialProfilesCount =
        subscriptionPlan === 'trial'
            ? trialPlanOptions.nb_social_profiles
            : subscription.options.profiles.count_total;
    const data = displayedData[variant];
    return (
        <div className="flex flex-col space-y-2.5" data-testid="new-plan-layout">
            <UserPlanCard />
            <DataWrapper
                title={
                    <Trans
                        i18nKey={data.users.title}
                        values={{ count: userCount }}
                        components={{ 0: <span className={textStyle[variant]} /> }}
                    />
                }
                description={t(data.users.description, {
                    count: userCount
                })}
            />
            <DataWrapper
                title={
                    <Trans
                        i18nKey={data.social_profiles.title}
                        values={{ count: SocialProfilesCount }}
                        components={{ 0: <span className={textStyle[variant]} /> }}
                    />
                }
                description={
                    <Trans
                        i18nKey={data.social_profiles.description}
                        components={{
                            0: (
                                <Link
                                    href={marketingUrl('contact')}
                                    target="_blank"
                                    rel="help noopener noreferrer"
                                    className="text-icoBlue underline"
                                />
                            )
                        }}
                    />
                }
            />
            <DataWrapper
                title={
                    <Trans
                        i18nKey={data.data_retention.title}
                        values={{ count: getDataRetention(variant) }}
                        components={{ 0: <span className={textStyle[variant]} /> }}
                    />
                }
                description={t(data.data_retention.description, {
                    count: getDataRetention(variant)
                })}
            />
        </div>
    );
}
